import "./DeveloperTemplate.css";

import React from "react";

import { NavigationActiveElement } from "../../models";
import { LeftNavigationBar } from "../../widget";

export interface DeveloperTemplateProps {
  children: React.ReactNode;
  activeElement?: NavigationActiveElement;
  fullHeight?: boolean;
  fullWidth?: boolean;
}

export const DeveloperTemplate: React.FC<DeveloperTemplateProps> = ({
  activeElement,
  children,
  fullHeight = false,
  fullWidth = false,
}): JSX.Element => {
  return (
    <div className={`DeveloperScreen${fullHeight ? " DeveloperScreen_fullHeight" : ""}`}>
      <div className="Navigation">
        <LeftNavigationBar activeItem={activeElement} />
      </div>
      <div className={`DeveloperContainer${fullWidth ? " DeveloperContainer_fullWidth" : ""}`}>{children}</div>
    </div>
  );
};
